import SectionContainer from 'modules/core/components/SectionContainer'

import Settings from 'modules/personal_settings/components/Settings'
import CollectionsBootstrap from 'modules/personal_settings/lib/CollectionsBootstrap'

const SettingsPage = () => {
  return (
    <CollectionsBootstrap>
      <SectionContainer>
        <Settings />
      </SectionContainer>
    </CollectionsBootstrap>
  )
}

export default SettingsPage
